import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allDrivers: [],
  editDriver:{},
  searchDriver:[],
  isLoading: false,
};

const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    setAllDrivers(state, action) {
      state.allDrivers = action.payload.allDrivers;
    },
    setEditDriver(state, action) {
      console.log(action.payload)
      state.editDriver= action.payload.editDriver;
    },
    setEditDriverValue(state, action) {
      // const{key,value} = action.payload
      state.editDriver[action.payload.key] = action.payload.value
    },
    setSearchDriver(state, action) {
      state.searchDriver = action.payload.searchDriver;
    },
    setLoading (state, action) {
      state.isLoading = action.payload.isLoading;
    },
  },
});

export const { setAllDrivers,setEditDriver,setEditDriverValue, setSearchDriver, setLoading} = driverSlice.actions;
export const driverReducer = driverSlice.reducer;
